import { createFileRoute, useLocation } from '@tanstack/react-router';
import messages from 'app/_authenticated/funds/messages';
import SEO from 'components/Seo/Seo';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import { BankWithdrawDetailsEditComponent } from './components/BankWithdrawDetailsEdit';

export const Route = createFileRoute(
  '/_authenticated/funds/withdraw/fiat/$productCode/bank-details/edit',
)({
  component: BankWithdrawDetailsEdit,
});

function BankWithdrawDetailsEdit() {
  const location = useLocation();
  const { language } = useSelector(
    (rootState: RootState) => rootState.language,
  );

  const fundsMessages = messages[language].seo;

  return (
    <>
      <SEO
        title={fundsMessages.title}
        description={fundsMessages.description}
        keywords={fundsMessages.keywords}
        page={location.pathname}
      />
      <div className="px-6 py-4">
        <BankWithdrawDetailsEditComponent />
      </div>
    </>
  );
}
